<template>
  <div>
    <!-- 文章資訊 -->
    <div class="block mb-5">
      <!-- News Title -->
      <label class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>News Tilte</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="form-input-group mb-1">
            <input type="text" />
          </div>
          <div class="h5 ink-02-medium--text text-right">0/50</div>
        </div>
      </label>
      <!-- 設定日期 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-3">設定日期</h4>
          <div class="h5 ink-02-medium--text mb-3">
            前台將依設定日期顯示文章的發佈日
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <SimpleSelectWithSearch
            class="mr-5"
            buttonPlaceholder="請選擇年份"
            buttonWidth="200px"
            modalBodyHeight="208px"
            modalWidth="200px"
            :options="options.year"
            :selectedValue.sync="year"
          ></SimpleSelectWithSearch>
          <SimpleSelectWithSearch
            class="mr-5"
            buttonPlaceholder="請選擇月份"
            buttonWidth="200px"
            modalBodyHeight="208px"
            modalWidth="200px"
            :options="options.month"
            :selectedValue.sync="month"
          ></SimpleSelectWithSearch>
          <SimpleSelectWithSearch
            class="mr-5"
            buttonPlaceholder="請選擇日期"
            buttonWidth="200px"
            modalBodyHeight="208px"
            modalWidth="200px"
            :options="options.date"
            :selectedValue.sync="date"
          ></SimpleSelectWithSearch>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="isShow"></FormSwitch>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於新聞列表Overview頁面 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader></ImgUploader>
        </div>
      </div>
    </div>

    <!-- TextEditor -->
    <TextEditor titleButton photoButton :bodyMinHeight="600"></TextEditor>
  </div>
</template>

<script>
import SimpleSelectWithSearch from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import TextEditor from '@/components/TextEditor.vue';

export default {
  components: {
    SimpleSelectWithSearch,
    FormSwitch,
    ImgUploader,
    TextEditor,
  },
  data: () => ({
    year: '',
    month: '',
    date: '',
    isShow: false,
    // options
    options: {
      year: [...Array(100).keys()].map((i) => i + 1991),
      month: [...Array(12).keys()].map((i) => i + 1),
      date: [...Array(31).keys()].map((i) => i + 1),
    },
  }),
};
</script>

<style></style>
